<template>
  <div class="fill-height">
    <!--Header-->
    <div
      style="gap: 8px"
      class="d-flex flex-wrap white px-8 pt-4 align-center justify-space-between"
    >
      <div>
        <h1 class="my-2">Mensajería instantánea</h1>
      </div>
    </div>

    <div class="py-6 px-4">
      <div v-if="connected" class="px-4 py-2 rounded-lg grey lighten-3">
        <v-row>
          <v-col cols="12" md="6">
            <div class="text-h6">
              Información de dispositivo conectado
            </div>

            <div class="mt-3">
              <div class="mb-3">
                <v-avatar size="92">
                  <v-img :src="info.avatar"></v-img>
                </v-avatar>
              </div>

              <div>
                <span class="font-weight-medium">Nombre:</span>
                {{ info.pushname }}
              </div>

              <div>
                <span class="font-weight-medium">Teléfono:</span>
                {{ info.me.user }}
              </div>

              <div class="mt-3" v-if="false">
                <v-btn
                  depressed
                  color="primary"
                  class="rounded-lg"
                  @click="logout"
                >
                  cerrar sesión
                </v-btn>
              </div>
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="text-h6">
              Probar envío de mensajes
            </div>

            <div class="mt-3">
              <div>
                <v-text-field
                  class="rounded-lg"
                  dense
                  outlined
                  label="Número"
                  type="number"
                  v-model="messageData.number"
                  hint="Usar formato internacional. E.g: 5493482302735"
                  persistent-hint
                  :rules="[
                    v =>
                      (v || '').length === 13 ||
                      'Debe seguir el formato internacional. E.g: 5493482302735'
                  ]"
                >
                </v-text-field>
              </div>

              <div class="mt-2">
                <v-textarea
                  class="rounded-lg"
                  dense
                  rows="3"
                  outlined
                  label="Mensaje"
                  v-model="messageData.message"
                  hide-details
                >
                </v-textarea>
              </div>

              <div class="mt-5">
                <v-btn
                  depressed
                  color="primary"
                  class="rounded-lg"
                  @click="sendMessage"
                >
                  enviar
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>

      <div class="px-4" v-else>
        <div
          class="d-flex flex-column flex-md-row align-center"
          style="gap: 12px"
        >
          <v-img width="400" height="400" :src="qrCodeUrl"></v-img>
          <div class="primary white--text py-3 px-6 rounded-lg">
            <div class="font-weight-medium text-h6">
              Cómo vincular un dispositivo
            </div>

            <div class="font-weight-medium">
              Android
            </div>
            1. Abre WhatsApp en tu teléfono con Android principal. <br />
            2. Toca el ícono <v-icon color="white">mdi-dots-vertical</v-icon> >
            Dispositivos vinculados > Vincular un dispositivo. <br />
            Si tu dispositivo permite la autenticación mediante rasgos
            biométricos, sigue las instrucciones que aparecen en pantalla.
            <br />
            Si no tienes activada la opción de autenticación biométrica, se te
            pedirá que ingreses el PIN que usas para desbloquear el teléfono.
            <br />
            3. Apunta la cámara de tu teléfono con Android a la pantalla del
            dispositivo que quieras vincular para escanear el código QR. <br />
            <div class="font-weight-medium mt-3">
              iPhone
            </div>
            1. Abre WhatsApp en tu iPhone principal. En WhatsApp, ve a
            Configuración > Dispositivos vinculados > Vincular un dispositivo.
            <br />
            2. Desbloquea tu iPhone <br />
            Si tienes iOS 14 o una versión posterior: Usa Touch ID o Face ID
            para desbloquearlo. Si no tienes activada la opción de autenticación
            biométrica, se te pedirá que ingreses el PIN que usas para
            desbloquear el teléfono. <br />
            3. Apunta la cámara de tu iPhone a la pantalla del dispositivo que
            quieras vincular para escanear el código QR.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import QRCode from "qrcode";

export default {
  name: "Home",

  data: () => ({
    qrCodeUrl: null,
    connected: false,
    loading: 0,
    info: null,
    chats: [],
    messageData: {
      message: null,
      number: null
    }
  }),

  created() {
    if (this.currentUser) {
      this.fetchInfo();
      this.connectToSocket();
    }
  },

  watch: {
    currentUser(user) {
      this.fetchInfo();
      this.connectToSocket();
    },

    info(val) {
      if (val) this.fetchChats();
    }
  },

  computed: {
    ...mapGetters(["currentUser"])
  },

  methods: {
    async sendMessage() {
      const response = await fetch("https://chatbot.inmanager.com.ar/send-message", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          userId: this.currentUser.id,
          ...this.messageData
        })
      });

      if (response.ok) {
        this.messageData = {
          message: null,
          number: null
        };

        alert("Mensaje enviado!");
      } else {
        alert("Envío fallido.");
      }
    },

    async logout() {
      const response = await fetch("https://chatbot.inmanager.com.ar/logout", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });

      if (response.ok) {
        this.$router.go();
      } else {
        alert(
          "No se pudo cerrar sesión de forma remota. Intente desde el dispositivo vinculado."
        );
      }
    },

    async fetchInfo() {
      const response = await fetch(
        `https://chatbot.inmanager.com.ar/${this.currentUser.id}`
      );
      const data = await response.json();

      this.info = data.info;

      if (this.info) {
        console.log(this.info);
        this.connected = true;
      }
    },

    async fetchChats() {
      const response = await fetch(
        `https://chatbot.inmanager.com.ar/${this.currentUser.id}/chats`
      );
      const data = await response.json();

      this.chats = data.data;

      console.log(this.chats);

      this.fetchChatMessages(this.chats[0].id._serialized);
    },

    async fetchChatMessages(id) {
      const response = await fetch(
        `https://chatbot.inmanager.com.ar/${this.currentUser.id}/chats/${id}/messages`
      );
      const data = await response.json();

      const messages = data.data;

      console.log(messages);
    },

    connectToSocket() {
      const socket = new WebSocket(
        `wss://chatbot.inmanager.com.ar/${this.currentUser.id}`
      );

      socket.onmessage = event => {
        const data = JSON.parse(event.data);
        if (data.qrCode) {
          QRCode.toDataURL(data.qrCode, (err, url) => {
            if (!err) {
              this.qrCodeUrl = url;
            }
          });
        }

        if (data.loading) {
          this.connected = true;
          this.loading = data.loading;
        }

        if (data.info) {
          this.info = data.info;

          if (this.info) {
            console.log(this.info);
            this.connected = true;
          }
        }

        if (data.connected) this.connected = true;
        if (data.disconnected) this.connected = false;
      };

      socket.onopen = function() {
        console.log("WebSocket connection established");
      };

      socket.onclose = function() {
        console.log("WebSocket connection closed");
      };

      socket.onerror = function(error) {
        console.error("WebSocket error:", error);
      };
    }
  }
};
</script>
